module.exports = __webpack_public_path__ + "static/img/DRGS.cd99b18.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/home/DRGS.jpg
// module id = oOND
// module chunks = 1